"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SubdirectoryArrowRight_exports = {};
__export(SubdirectoryArrowRight_exports, {
  default: () => SubdirectoryArrowRight_default
});
module.exports = __toCommonJS(SubdirectoryArrowRight_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.3281 13.5898H8.83984C8.25391 13.5898 7.71354 13.4792 7.21875 13.2578C6.71094 13.0365 6.26823 12.737 5.89062 12.3594C5.51302 11.9818 5.21354 11.5391 4.99219 11.0312C4.77083 10.5365 4.66016 9.99609 4.66016 9.41016V4.41016C4.66016 4.1888 4.73828 4 4.89453 3.84375C5.0638 3.67448 5.26562 3.58984 5.5 3.58984C5.73438 3.58984 5.92969 3.67448 6.08594 3.84375C6.25521 4 6.33984 4.1888 6.33984 4.41016V9.41016C6.33984 10.1003 6.58073 10.6927 7.0625 11.1875C7.55729 11.6693 8.14974 11.9102 8.83984 11.9102H14.3281L12.4141 10.0156C12.2448 9.84635 12.1602 9.65104 12.1602 9.42969C12.1602 9.19531 12.2448 8.99349 12.4141 8.82422C12.5703 8.66797 12.7656 8.58984 13 8.58984C13.2344 8.58984 13.4297 8.66797 13.5859 8.82422L16.9258 12.1641C17.082 12.3203 17.1602 12.5156 17.1602 12.75C17.1602 12.9844 17.082 13.1797 16.9258 13.3359L13.5859 16.6758C13.4297 16.832 13.2344 16.9102 13 16.9102C12.7656 16.9102 12.5703 16.832 12.4141 16.6758C12.2448 16.5065 12.1602 16.3112 12.1602 16.0898C12.1602 15.8555 12.2448 15.6536 12.4141 15.4844L14.3281 13.5898Z",
      fill: "currentColor"
    }
  )
);
const SvgSubdirectoryArrowRight = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var SubdirectoryArrowRight_default = SvgSubdirectoryArrowRight;
